module.exports = __webpack_public_path__ + "img/heartRate.e2386f7b.svg";